import Referanser from './referanser.jsx'
import { motion } from 'framer-motion'
import React from 'react';
import { useCallback } from 'react';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
function Main() {
  const particlesInit = useCallback(async engine => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    //await loadFull(engine);
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async container => {
    await console.log(container);
  }, []);


  return (
    <div>

      <Particles className='bakgrunn' id="tsparticles"
        options={{
          background: {
            color: {
              value: "#394319",
            },
          },
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: false,
                mode: "push",
              },
              onHover: {
                enable: false,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: false,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
        }}
        init={particlesInit}
        loaded={particlesLoaded} />
      <header className="App-header">
        <motion.pre
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1.4 }}
          transition={{ delay: 1, duration: 1, bounce: 1, type: 'spring' }}
          className='App-asciilogo'>
          __  __    __   _ <br />
          \ \/ /___/ /__(_)<br />
          \  / __/  &apos;_// /<br />
          /_/_/ /_/\_\/_/ <br />
          <br />
        </motion.pre>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.2 }}
          className='undertekst'>
          systemutvikling / c# / typescript / dotnet / react
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.2 }}
        >
          <a href="mailto:thomas@yrki.no">thomas@yrki.no</a> / <a href="tel:+4790039442">+47 900 39 442</a> / <a href="https://www.linkedin.com/in/thomaspettersen/">LinkedIn</a>
        </motion.div>

      </header>
      <Referanser />
    </div >
  )
}

export default Main;